import { normalize, denormalize, schema } from 'normalizr';
import {
  getNotesByJob,
  createNotesByJob,
  updateNotesByJob,
  deleteNotesByJob,
} from '@homeservices/api-kit/proreferral/pronotes/v2';
import commonJobsStore from '@/store/common-modules/jobs';
import {
  NEW_MATCHES,
  CURRENT_MATCHES,
  PAST_MATCHES,
} from '@/constants/match-statuses';


const noteSchema = new schema.Entity('notes', {}, {
  idAttribute: value => `${value.jobId}-${value.skillsProfileId}`,
});

export default {
  namespaced: true,
  state () {
    return {
      notes: {},
    };
  },
  modules: {
    commonJobsStore,
  },
  getters: {
    getNote: state => ({ jobId, skillsProfileId }) => {
      return denormalize(state.notes[`${jobId}-${skillsProfileId}`], noteSchema, state) || {};
    },
    // TODO remove these
    newJobs: (state, getters) => getters.getStructuredDataByStatusGroup(NEW_MATCHES),
    currentJobs: (state, getters) => getters.getStructuredDataByStatusGroup(CURRENT_MATCHES),
    pastJobs: (state, getters) => getters.getStructuredDataByStatusGroup(PAST_MATCHES),
  },
  actions: {
    async fetchProNotes ({ commit, getters }, { jobId, ...params }) {
      const job = getters.getJob(jobId);

      const { data } = await getNotesByJob(job.id, {
        skills_profile: job.match.skills_profile,
        ...params,
      });

      // Transform notes
      const notes = data.map(note => ({
        ...note,
        jobId: job.id,
        skillsProfileId: job.match.skills_profile,
      }));

      const { entities } = normalize(notes, [noteSchema]);
      commit('updateProJobsState', { entities });
    },
    async saveProNotes ({ dispatch, getters }, { jobId, content, ...params }) {
      const job = getters.getJob(jobId);
      const note = getters.getNote({ jobId, skillsProfileId: job.match.skills_profile });
      const hasNote = Object.keys(note).length;

      const paramsToSend = {
        content,
        skills_profile: job.match.skills_profile,
        ...params,
      };

      const response = hasNote
        ? await updateNotesByJob(job.id, note.id, paramsToSend)
        : await createNotesByJob(job.id, paramsToSend);


      dispatch('fetchProNotes', { jobId: job.id });
      return response;
    },
    async deleteProNotes ({ commit, getters }, { jobId, noteId }) {
      await deleteNotesByJob(jobId, noteId);

      const job = getters.getJob(jobId);

      commit('deleteProJobsNote', { jobId, skillsProfileId: job.match.skills_profile });
    },
  },
  mutations: {
    updateProJobsState (state, { entities }) {
      const newEntities = { ...entities };

      Object.keys(newEntities).forEach((entityName) => {
        const entity = newEntities[entityName];

        state[entityName] = {
          ...state[entityName],
          ...entity,
        };
      });
    },
    addNotesToProJob (state, { jobId, notes = [] }) {
      state.commonJobsStore[jobId].notes = notes;
    },
    deleteProJobsNote (state, { jobId, skillsProfileId }) {
      delete state.notes[`${jobId}-${skillsProfileId}`];
    },
  },
};
